import React from "react";

function PdfPreviewModal({ isOpen, onClose, pdfUrl, onDownload }) {
  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <iframe
          src={pdfUrl}
          title="PDF Preview"
          style={styles.iframe}
        ></iframe>
        <div style={styles.buttonRow}>
          <button onClick={onDownload} style={styles.downloadBtn}>📥 İndir</button>
          <button onClick={onClose} style={styles.closeBtn}>❌ Kapat</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
  },
  modal: {
    backgroundColor: "white", borderRadius: "8px", padding: "1rem", width: "80%", height: "80%", display: "flex", flexDirection: "column"
  },
  iframe: {
    flex: 1, border: "none", borderRadius: "4px", marginBottom: "1rem"
  },
  buttonRow: {
    display: "flex", justifyContent: "flex-end", gap: "1rem"
  },
  downloadBtn: {
    padding: "0.5rem 1rem", backgroundColor: "#28a745", color: "white", border: "none", borderRadius: "4px", cursor: "pointer"
  },
  closeBtn: {
    padding: "0.5rem 1rem", backgroundColor: "#dc3545", color: "white", border: "none", borderRadius: "4px", cursor: "pointer"
  }
};

export default PdfPreviewModal;
